<template>
	<view class="chat">
		<view class="search">
			<view class="search_item" v-if="['0', '3'].includes(this.type)">
				<view class="search_item_label">KPI</view>
				<view class="search_item_value">数量</view>
			</view>
			<view class="search_item" v-if="['2'].includes(this.type)" @click="$refs.pengTree._show()">
				<view class="search_item_label">位置</view>
				<view class="search_item_value">{{ model.localtionId ? model.localtionName : '全部' }}</view>
			</view>
			<view class="search_item" v-if="['2'].includes(this.type)" @click="openZT">
				<view class="search_item_label">主题</view>
				<view class="search_item_value">{{ model.typeId ? model.typeName : '全部' }}</view>
			</view>
			<view class="search_item" @click="openRQ">
				<view class="search_item_label">日期</view>
				<view class="search_item_value">{{model.queryTypeName ? model.queryTypeName : '按月'}}</view>
			</view>
		</view>
		<view class="chat">
			<!-- SHE图表 -->
			<view ref="chartContainer" id="chartContainer" class="chat_tu" v-if="type === '0'"></view>
			<!-- 跌绊滑风险上报图表 -->
			<view ref="chartContainer1" id="chartContainer1" class="chat_tu" v-if="type === '3'"></view>
			<!-- DCA图表 -->
			<view ref="chartContainer2" id="chartContainer2" class="chat_tu" v-if="type === '2'"></view>
		</view>
		<!-- 日期 -->
		<u-picker :show="show" :columns="columns" keyName="label" @cancel="closeRQ" @confirm="confirmDate"></u-picker>
		<!-- 主题 -->
		<u-picker
			:show="show2"
			:columns="theme"
			keyName="name"
			@confirm="selectTheme"
			@cancel="closeZT" />
		<!-- 位置 -->
		<peng-tree
			ref="pengTree"
			:range="address"
			idKey="id"
			:selectParent="false"
			nameKey="name"
			:multiple="false"
			title="选择位置"
			@confirm="selectAddress"
			@cancel="$refs.pengTree._hide()" />
	</view>
</template>

<script>
	import * as echarts from 'echarts'
	import pengTree from '@/uni_modules/peng-tree/peng-tree/peng-tree.vue'
	export default {
		components: { pengTree },
		data() {
			return {
				type: '',
				show: false,
				show2: false,
				columns: [
					[
						{ label: '按月', id: 0 },
						{ label: '按季度', id: 1}
					]
				],
				model: {
					name: '数量',
					queryType: 0,
					queryTypeName: '',
					typeId: '',
					typeName: '',
					localtionId: '',
					localtionName: ''
				},
				address: [],
				theme: []
			};
		},
		onLoad(option) {
			this.type = option.type
			this.initData(option.type)
			this.getLocation()
			this.getZhuti()
		},
		methods: {
			openZT() {
				this.stopScroll()
				this.show2 = true
			},
			closeZT() {
				this.canScroll()
				this.show2 = false
			},
			openRQ() {
				this.stopScroll()
				this.show = true
			},
			closeRQ() {
				this.canScroll()
				this.show = false
			},
			// 初始化数据
			async initData() {
				let res = await this.$u.api.getWorkOrderData({
					orderType: this.type,
					queryType: this.model.queryType,
					locationId: this.model.localtionId,
					typeId: this.model.typeId
				})
				if (res.code === 200) {
					if (this.type === '0') {
						let initChart = res.data.map(item => item.dateStr)
						let seriesData = res.data.map(item => item.total)
						this.$nextTick(() => {
							this.initChart(initChart, seriesData)
						})
					} else if (this.type === '3') {
						let initChart = res.data.map(item => item.dateStr)
						let seriesData = [
							{
								name: 'SHE关闭',
								type: 'bar',
								stack: 'total',
								label: {
									show: true,
									color: '#ffffff'
								},
								// itemStyle: {
								// 	color: '#000000'
								// },
								emphasis: {
									focus: 'series'
								},
								data: []
							},
							{
								name: 'WTS关闭',
								type: 'bar',
								stack: 'total',
								label: {
									show: true,
									color: '#ffffff'
								},
								emphasis: {
									focus: 'series'
								},
								data: []
							},
							{
								name: '工程师关闭',
								type: 'bar',
								stack: 'total',
								label: {
									show: true,
									color: '#ffffff'
								},
								emphasis: {
									focus: 'series'
								},
								data: []
							},
							{
								name: '未关闭',
								type: 'bar',
								stack: 'total',
								label: {
									show: true,
									color: '#ffffff'
								},
								emphasis: {
									focus: 'series'
								},
								data: []
							}
						]
						res.data.forEach(item => {
							seriesData[0].data.push(item.sheTotal)
							seriesData[1].data.push(item.wtsTotal)
							seriesData[2].data.push(item.gcsTotal)
							seriesData[3].data.push(item.unCloseTotal)
						})
						this.$nextTick(() => {
							this.initChart1(initChart, seriesData)
						})
					} else if (this.type === '2') {
						let initChart = res.data.map(item => item.dateStr)
						let seriesData = [
							{
								name: '不符合数',
								type: 'bar',
								label: {
									show: true,
									color: '#3875C5',
									position: 'right'
								},
								data: []
							},
							{
								name: '已解决数',
								type: 'bar',
								label: {
									show: true,
									color: '#3875C5',
									position: 'right'
								},
								data: []
							}
						]
						res.data.forEach(item => {
							seriesData[0].data.push(item.total)
							seriesData[1].data.push(item.total - item.unCloseTotal)
						})
						console.log(seriesData)
						this.$nextTick(() => {
							this.initChart2(initChart, seriesData)
						})
					}
				}
			},
			confirmDate(e) {
				this.model.queryType = e.value[0].id
				this.model.queryTypeName = e.value[0].label
				this.initData()
				this.canScroll()
				this.show = false
			},
			// dac位置
			async getLocation() {
				let res = await this.$u.api.categoryTree({ categoryType: 3 })
				if (res.code === 200) {
					res.data.unshift({ name: '全部', id: '', childList: [] })
					this.address = res.data
				}
			},
			// dac主题
			async getZhuti() {
				let res = await this.$u.api.categoryList({ categoryType: 4, isRoot: 1 })
				if (res.code === 200) {
					res.data.unshift({ name: '全部', id: '', childList: [] })
					this.theme = [res.data]
				}
			},
			// 选择主题
			selectTheme(e) {
				this.model.typeId = e.value[0].id
				this.model.typeName = e.value[0].name
				this.initData()
				this.canScroll()
				this.show2 = false
			},
			// 选择位置
			selectAddress(e) {
				this.model.localtionId = e[0].id
				this.model.localtionName = e[0].name
				this.initData()
				this.$refs.pengTree._hide()
			},
			// SHE图表
			initChart(yAxisData, seriesData) {
				var chartDom = document.getElementById('chartContainer');
				var myChart = echarts.init(chartDom);

				var option;

				option = {
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'shadow'
						}
					},
					legend: {},
					grid: {
						left: '3%',
						right: '4%',
						bottom: '3%',
						containLabel: true
					},
					xAxis: {
						type: 'value',
						boundaryGap: [0, 0.01]
					},
					yAxis: {
						type: 'category',
						data: yAxisData
					},
					series: [{
						name: '上报数量',
						type: 'bar',
						label: {
							show: true,
							color: '#3875C5',
							position: 'right'
						},
						data: seriesData
					}]
				};

				option && myChart.setOption(option);
			},
			// 跌绊滑风险上报图表
			initChart1(yAxisData, seriesData) {
				var chartDom = document.getElementById('chartContainer1');
				var myChart = echarts.init(chartDom);

				var option;

				option = {
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'shadow'
						}
					},
					legend: {},
					grid: {
						left: '3%',
						right: '4%',
						bottom: '3%',
						containLabel: true
					},
					xAxis: {
						type: 'value'
					},
					yAxis: {
						type: 'category',
						data: yAxisData
					},
					series: seriesData
				};

				option && myChart.setOption(option);
			},
			// DCA图表
			initChart2(yAxisData, seriesData) {
				var chartDom = document.getElementById('chartContainer2');
				var myChart = echarts.init(chartDom);

				var option;

				option = {
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'shadow'
						}
					},
					legend: {},
					grid: {
						left: '3%',
						right: '4%',
						bottom: '3%',
						containLabel: true
					},
					xAxis: {
						type: 'value',
						boundaryGap: [0, 0.01]
					},
					yAxis: {
						type: 'category',
						data: yAxisData
					},
					series: seriesData
				};

				option && myChart.setOption(option);
			}
		}
	}
</script>

<style lang="scss" scoped>
	.chat {
		width: 100%;

		.search {
			width: 100%;

			.search_item {
				width: 100%;
				height: 92rpx;
				display: flex;
				align-items: center;
				border-bottom: 1rpx solid #EFEFEF;

				.search_item_label {
					width: 180rpx;
					height: 100%;
					flex-shrink: 0;
					display: flex;
					align-items: center;
					justify-content: center;
					color: rgba(16, 16, 16, 1);
					font-size: 28rpx;
				}

				.search_item_value {
					flex: 1;
					height: 100%;
					display: flex;
					align-items: center;
					justify-content: start;
					color: rgba(16, 16, 16, 1);
					font-size: 28rpx;
				}
			}
		}

		.chat {
			width: 100%;
			height: 800rpx;
			padding: 0 30rpx;
			box-sizing: border-box;
			margin-top: 90rpx;

			.chat_tu {
				width: 100%;
				height: 100%;
			}
		}
	}
</style>